import _ from 'lodash'
import axios from 'axios'
import {getAppInst, getAppName} from "util/AppName";
import {jsonToParamString} from 'util/api/jsonToParamString';

const appName = getAppName()
const appinst = getAppInst()
if (!appName) {
	console.error("No application name defined");
} else {
	axios.defaults.headers.sisAppName = appName;
	if (appinst) axios.defaults.headers.appinst = appinst;
}

axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache'; // IE

axios.interceptors.request.use(function (config) {
	return {paramsSerializer: jsonToParamString, ...config};
}, function (error) {
	// Do something with request error
	return Promise.reject(error);
});

axios.interceptors.response.use(
	function (response) {
		return response;
	},
	function (error) {
		if (_.get(error, ['response', 'status']) === 403) {
			window.location.reload();
		}
		throw error;
	},
);

window.sis = {
	...window.sis,
	axios,
}